<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I sold a book</h1>

			<div v-if="!loading">
				<div v-if="!inventory.length">
					<p>
						We see you don’t have any sold items in this account, please contact customer
						service if you are having trouble finding your account.
					</p>

					<email-form
							caption="Contact Us"
							subject="Having trouble finding my account"
							:body="email_body"
							on-success-url="/help?#/submitted"
							edit-body
							edit-subject
							must-edit
							destination-key="cs"
					></email-form>
				</div>
				<div v-else>
					<ul class="h-inventory">
						<li v-for="(item, index) in inventory" tabindex="0">
							<v-flex xs12>
								<v-card color="" class="">
									<v-layout>
										<v-flex xs2>
											<v-img
													:src="item['book_cover'] || '/img/no_image_medium.gif'"
													height="90px"
													contain
													class="mt-3"
											></v-img>
										</v-flex>
										<v-flex xs8>
											<v-card-title primary-title>
												<div>
													<div class="">{{ item['book_title'] }}</div>
													<div>{{ item['book_author'] }}</div>
													<div>{{ item['isbn'] }}</div>
													<div>{{ `Purchased by ${item['buyer_username']} for $${item['price']}` }}</div>
												</div>
											</v-card-title>
										</v-flex>
										<v-flex xs2 class="pt-3">
											<v-btn color="#7DADED" large round dark small @click="$router.push('/sales_questions/' + item.item_id)">Pick</v-btn>
										</v-flex>
									</v-layout>
									<v-divider light></v-divider>
								</v-card>
							</v-flex>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<base-nav-links home no-back></base-nav-links>
	</div>
</template>

<script>
	import Axios from 'axios';
	import BaseNavLinks from './../components/BaseNavLinks';
	import EmailForm from "./../components/EmailForm";
	import _ from 'lodash';

	export default {
		name: "MySales",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				loading: false,
				inventory: [],
				email_body: "I can't figure out which account I used to sell my book, can you help?",
			};
		},

		mounted() {
			const self = this;
			self.loading = true;

			_.defer(function () {
				self.$eventHub.$emit('show-loader', true);
			});

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_sales_orders/?all_except_canceled=true')
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						self.inventory = response.data['data'];
					}
				})
				.finally(function () {
					self.loading = false;
					self.$eventHub.$emit('hide-loader');
				});
		},
	}
</script>

<style scoped lang="less">
	ul.h-inventory {
		padding-left: 0;

		> li {
			list-style: none;
		}
	}

</style>